var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowAltToBottom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  className: "arrow-alt-to-bottom_svg__svg-inline--fa arrow-alt-to-bottom_svg__fa-arrow-alt-to-bottom arrow-alt-to-bottom_svg__fa-w-12 arrow-alt-to-bottom_svg__fa-9x",
  "data-icon": "arrow-alt-to-bottom",
  "data-prefix": "fas",
  viewBox: "0 0 384 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M360 480H24c-13.3 0-24-10.7-24-24v-24c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24v24c0 13.3-10.7 24-24 24M128 56v136H40.3c-17.8 0-26.7 21.5-14.1 34.1l152.2 152.2c7.5 7.5 19.8 7.5 27.3 0l152.2-152.2c12.6-12.6 3.7-34.1-14.1-34.1H256V56c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24"
})));
export { SvgArrowAltToBottom as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-alt-to-bottom.73b86bfd.svg";